export const logoRoutesMap = {
  gestion: {
    path: '/logo/gestion',
    name: 'Logo Empresa',
  },
}
